<template>
  <div class="appAdBody">
    <!-- header -->
    <el-card>
      <el-row class="top_row" :gutter="20">
        <el-col :span="6">
          <el-input
            placeholder="请输入关键字搜索"
            class="input-with-select"
            clearable
            v-model="queryInfo.keyword"
            @clear="adBodyTemplatePageFn"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="adBodyTemplatePageFn"
            ></el-button>
          </el-input>
        </el-col>
        <el-col :span="8" >
          <el-button type="primary" size="mini" @click="createAd('create')"
          >新增广告边框主题
          </el-button
          >
        </el-col>
      </el-row>
      <el-row>
      </el-row>
    </el-card>
    <!-- body -->
    <el-card>
      <vxe-table
        resizable
        ref="lockTable"
        align="center"
        :data="lockInfoList"
        :loading="loading"
      >
      <vxe-column type="checkbox" width="60"></vxe-column>
        <vxe-column type="seq" width="50" title="序号"></vxe-column>
        <vxe-column field="theme" title="广告边框主题"></vxe-column>
        <vxe-column field="createTime" title="创建时间"></vxe-column>
        <vxe-column title="是否启用" width="150">
            <template #default="{ row }">
              <el-switch
              :value="row.isUsed"
              :active-value="1"
              :inactive-value="0"
              @change="switchAdStatus(row)"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="启用"
              inactive-text="禁用"
            >
            </el-switch>
            </template>
         </vxe-column>
         <vxe-column field="remarks" title="备注"></vxe-column>
         <vxe-column title="操作" width="300">
            <template #default="{ row }">
              <el-button
                  type="warning"
                  size="mini"
                  @click="createAd('edit',row)"
                  >编辑</el-button
                >
                <el-button
                @click="deleteAd(row.id)"
                  type="danger"
                  size="mini"
                  >删除广告</el-button
                >
            </template>
         </vxe-column>
      </vxe-table>
    </el-card>
    <base-pagination
      :total="total"
      :currentPage="queryInfo.pageNum"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></base-pagination>
    <add-ad-body-dialog :addData="addData" @successHandle="successHandle"></add-ad-body-dialog>
  </div>
</template>

<script>
import addAdBodyDialog from './dialog/addAdBodyDialog.vue'
import { adBodyTemplatePage, delTemplateById, adBodyTemplateSave } from '@/api/adv'
export default {
  data () {
    return {
      loading: false,
      addData: {
        title: '',
        id: '',
        isOpen: false
      },
      queryInfo: {
        pageNum: 1,
        pageSize: 10,
        keyword: ''
      },
      lockInfoList: [],
      orgaInfoList: [],
      total: 0
    }
  },
  components: {
    addAdBodyDialog
  },
  created () {
    this.adBodyTemplatePageFn()
  },
  methods: {
     // 获取广告列表
    adBodyTemplatePageFn () {
      this.loading = true
      adBodyTemplatePage(this.queryInfo).then((res) => {
        this.loading = false
        this.lockInfoList = res.data.list
        this.total = res.data.total
      })
    },
    // 改变分页条目
    handleSizeChange (size) {
      this.queryInfo.pageNum = 1
      this.queryInfo.pageSize = size
      this.adBodyTemplatePageFn()
    },
    // 改变页数
    handleCurrentChange (page) {
      this.queryInfo.pageNum = page
      this.adBodyTemplatePageFn()
    },
    // 新增广告
    createAd (type, item) {
      this.addData.isOpen = true
      if (type === 'create') {
        this.addData.id = ''
        this.addData.title = '新增广告边框主题'
      } else {
        this.addData.id = item.id
        this.addData.title = '编辑广告边框主题'
      }
    },
    // 删除广告
    deleteAd (val) {
      this.$confirm('此操作将永久删除该主题, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          delTemplateById(val).then((res) => {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            this.adBodyTemplatePageFn()
          })
        })
        .catch(() => {
          this.$message({
            type: 'warning',
            message: '已取消删除'
          })
        })
    },
    // 设置广告是否为首页轮播
    switchAdStatus (item) {
      const data = JSON.parse(JSON.stringify(item))
      data.isUsed = data.isUsed === 0 ? 1 : 0
      adBodyTemplateSave(data).then(() => {
          this.adBodyTemplatePageFn()
        })
    },
    // 监听成功添加与编辑
    successHandle () {
      this.$refs.lockTable.clearCheckboxRow()
      this.adBodyTemplatePageFn()
    }
  }
}
</script>

<style lang="scss" scoped>
.top_row {
  display: flex;
  align-items: center;
}
</style>
